import type { TaskCategory, TaskMode } from '@/types/prioritization/prioritizationTask';

type TaskLinkInput = {
  id: string;
  category?: TaskCategory;
  description?: string;
  sessionId?: string;
  mode?: TaskMode;
  name?: string;
};

/**
 * Where list surfaces (dashboard, notifications, My Tasks) should send the user.
 *
 * - Catchball proposal → loop workbench path in `description`
 * - Live session join → shared C Mode /participate → /live (not TaskRunner)
 * - Everything else → TaskRunner for async/scoring flows
 */
export function getTaskPrimaryHref(task: TaskLinkInput): string {
  if (
    task.category === 'catchball_proposal' &&
    typeof task.description === 'string' &&
    task.description.trim().startsWith('/')
  ) {
    return task.description.trim();
  }

  if (task.sessionId && isLiveSessionJoinTask(task)) {
    return `/prioritization/sessions/${task.sessionId}/participate`;
  }

  return `/prioritization/task/${task.id}`;
}

/** Live go-live invites must join the shared room, not the standalone TaskRunner. */
export function isLiveSessionJoinTask(task: TaskLinkInput): boolean {
  if (!task.sessionId) return false;
  if (task.mode === 'live') return true;
  const name = (task.name ?? '').toLowerCase();
  return name.startsWith('join live session');
}

export function isCatchballProposalWorkbenchPath(task: TaskLinkInput): boolean {
  return (
    task.category === 'catchball_proposal' &&
    typeof task.description === 'string' &&
    task.description.trim().startsWith('/')
  );
}
